import React, { Component } from 'react'
import { Modal, Tabs, Tab} from 'react-bootstrap';
import { connect } from 'react-redux';
import { SaveOnBoardingInfo } from './onBoarding.action';

import { Redirect } from 'react-router-dom';

import CompanyProfile from './comps/CompanyProfile';
import SelectPayers from './comps/SelectPayers';
import SelectBrokers from './comps/SelectBrokers';
// import '~/stylesheets/onBoardingSetup.modal.scss';
class SetupOnBoarding extends Component {
    constructor(props){
        super(props);
        this.state = {
            show: false,
            payers: [
                { label: 'Chocolate', value: 'chocolate' },
                { label: 'Vanilla', value: 'vanilla' },
                { label: 'Strawberry', value: 'strawberry' },
                { label: 'Caramel', value: 'caramel' },
                { label: 'Cookies and Cream', value: 'cookiescream' },
                { label: 'Peppermint', value: 'peppermint' },
            ],
            selectedPayers: [],
            brokers: [
                { label: 'Broker One', value: 'Broker One' },
                { label: 'Broker Two', value: 'Broker Two' },
                { label: 'Broker Three', value: 'Broker Three' },
                { label: 'Caramel', value: 'caramel' },
                { label: 'Cookies and Cream', value: 'cookiescream' },
                { label: 'Peppermint', value: 'peppermint' },
            ],
            selectedBrokers: [],
            // key: localStorage.getItem('ActiveTab') ? parseInt(localStorage.getItem('ActiveTab')) : 1,
            key: 1,
            onModalClose: false
        }
    }

    selectPayers = (payers) => {
        this.setState({selectedPayers: payers});
    }
    selectBrokers = (broker) => {
        this.setState({ selectedBrokers: broker});
    }

    onChangeTab = (key) => {
        this.setState({key});
        localStorage.setItem('ActiveTab', key);
    }

    tabEventHandler = () => {

        let vals = {
            company_name: document.getElementById('company_name').value,
            company_address: document.getElementById('company_address').value,
            company_city: document.getElementById('city').value,
            company_zip: document.getElementById('zip_code').value,
            company_state: document.getElementById('state').value,
            company_phone: document.getElementById('phone').value,
            company_billing_id: document.getElementById('billing_id').value,
            company_billing_tax_id: document.getElementById('tax_id').value,
            company_billing_npi: document.getElementById('billing_npi').value,
            company_billing_address: document.getElementById('billing_address').value,
            company_billing_address_2: document.getElementById('billing_address_2').value,
            company_billing_city: document.getElementById('billing_city').value,
            company_billing_zip: document.getElementById('billing_zip').value,
            company_billing_state: document.getElementById('billing_state').value,
            company_payers: document.getElementById('selectedPayers').getAttribute('value'),
            company_brokers: document.getElementById('selectedBrokers').getAttribute('value'),
            dispatch_info: document.getElementById('dispatchInfo').value
        }

        if(this.state.key === 1){
            if (vals.company_name !== "" && vals.company_address !== "" && vals.company_zip !== "" &&
                vals.company_city !== "" && vals.company_state !== "" && vals.company_billing_tax_id !== ""
                && vals.company_billing_address !== "" && vals.company_billing_city !== "" && vals.company_billing_id
                !== "" && vals.company_billing_npi !== "" && vals.company_billing_state !== ""
            ) {
                if (this.state.key !== 4) {
                    this.setState({ key: this.state.key + 1 })
                }
            }
        }
        else if(this.state.key === 2){
            if (this.state.selectedPayers.length !== 0
            ) {
                if (this.state.key !== 4) {
                    this.setState({ key: this.state.key + 1 })
                }
            }
        }
        else if(this.state.key === 3){
            if (this.state.selectedBrokers.length !== 0
            ) {
                if (this.state.key !== 4) {
                    this.setState({ key: this.state.key + 1 })
                }
            }
        }
        else{
            if (vals.dispatch_info !== ""
            ) {
                if (this.state.key !== 4) {
                    this.setState({ key: this.state.key + 1 })
                } else {
                    let formValues = this.props.formData();
                    let formDataStorage = JSON.parse(localStorage.getItem('tempOnboardingData'));

                    if (formValues.company_name && formValues.company_zip && formValues.company_address && formValues.company_city && formValues.company_state &&
                        formValues.company_billing_id && formValues.company_billing_tax_id && formValues.company_billing_npi && formValues.company_billing_address
                        && formValues.company_billing_city && formValues.company_billing_zip && formValues.company_billing_state && formValues.company_payers
                        && formValues.company_brokers && formValues.dispatch_info && formValues.company_billing_address_2 && formValues.company_phone) {
                        formValues.token = localStorage.getItem('authToken');
                        this.props.SaveOnBoardingInfo(formValues)
                            .then((res) => {
                                localStorage.removeItem('is_new');
                                localStorage.removeItem('ActiveTab');

                                this.setState({ onModalClose: true });
                                window.alert(res.data.message);
                            })
                            .catch((err) => {
                                window.alert("Data couldn't save to server");
                            })
                    } else if (formDataStorage.company_name && formDataStorage.company_zip && formDataStorage.company_address && formDataStorage.company_city && formDataStorage.company_state &&
                        formDataStorage.company_billing_id && formDataStorage.company_billing_tax_id && formDataStorage.company_billing_npi && formDataStorage.company_billing_address
                        && formDataStorage.company_billing_city && formDataStorage.company_billing_zip && formDataStorage.company_billing_state && formDataStorage.company_payers
                        && formDataStorage.company_brokers && formDataStorage.dispatch_info && formDataStorage.company_billing_address_2 && formDataStorage.company_phone) {
                        formDataStorage.token = localStorage.getItem('authToken');
                        this.props.SaveOnBoardingInfo(formDataStorage)
                            .then((res) => {
                                localStorage.removeItem('is_new');
                                localStorage.removeItem('ActiveTab');

                                this.setState({ onModalClose: true });
                                window.alert(res.data.message);
                            })
                            .catch((err) => {
                                window.alert("Data couldn't save to server");
                            })
                    }

                    else {
                        window.alert("Please complete first all of the fields");
                    }
                }
            }
        }
    }

    render () {

        if(this.state.onModalClose) {
            document.body.className = "fix_bgs";
            return <Redirect to="/" />
        }

        const TempData = JSON.parse(localStorage.getItem('tempOnboardingData'));
        let dispatch_info = TempData && TempData.dispatch_info;
        return (
            <div>
                <Modal show={this.props.show} onHide={this.props.onHideShowBoarding} backdrop='static'>
                    <Modal.Header className="boarding_header_wrapper">
                        <Modal.Title>
                            <div className="boarding_modal_header">
                                <h3>On boarding Setup</h3>
                                <span>On boarding Setup page</span>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <Tabs 
                            defaultActiveKey={1} 
                            animation={false} 
                            className="tabs_wrapper_boarding"
                            onSelect={this.onChangeTab}
                            activeKey={this.state.key}
                        >
                            <Tab disabled={true} eventKey={1} title="Company Profile" className="brding_cmn_tab_cls">
                                <CompanyProfile />
                            </Tab>
                            <Tab disabled={true} eventKey={2} title="Select Payers" className="brding_cmn_tab_cls">
                                <SelectPayers data={this.state.payers} onSelectPayers={this.selectPayers} selectedPayers={this.state.selectedPayers}/>
                            </Tab>
                            <Tab disabled={true} eventKey={3} title="Select Brokers" className="brding_cmn_tab_cls">
                                <SelectBrokers data={this.state.brokers} onSelectBrokers={this.selectBrokers} selectedBrokers={this.state.selectedBrokers}/>
                            </Tab>
                            <Tab disabled={true} eventKey={4} title="Dispatch" className="brding_cmn_tab_cls">
                                <div className="brd_tab_cntnt">
                                    <div className="brding_frm_ele">
                                        <span>Dispatch</span>
                                        <input defaultValue={dispatch_info} id="dispatchInfo" type="text" placeholder="Dispatch" />
                                    </div> <br />
                                </div>
                            </Tab>
                        </Tabs>
                    </Modal.Body>
                    <Modal.Footer className="brding_footer_wrapper">
                        <button onClick={this.props.onHideShowBoarding} className="cancel_btn_brding">Logout</button>
                        <button onClick={this.tabEventHandler} className="save_btn_brding">{ this.state.key === 4 ?  'Save' : 'Next'}</button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default connect(null, { SaveOnBoardingInfo })(SetupOnBoarding)


// WEBPACK FOOTER //
// ./src/app/setup_onboarding/SetupOnboarding.js